import GetAllLeadPartyRequest from "../../service/request/GetAllLeadPartyRequest";
import LeadPartyApi from "../../service/LeadPartyService";
import _ from "underscore";

export default {
  name: "LeadPartyListTable",
  props: {
    showSelect: { type: Boolean, default: false }
  },
  mixins: [],
  data: function() {
    return {
      applicationNameItems:['Herkese Borsa', 'Trade Master'],
      applicationName: null,
      applicationNameDisabled: false
    };
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "",
          value: "",
          filterable: false
        },
        {
          text: this.$t("tckn"),
          value: "tckn",
          filterable: true
        },
        {
          text: this.$t("full/Name"),
          value: "fullName",
          filterable: true
        },
        {
          text: this.$t("status_"),
          value: "hasNFCPhone",
          filterable: false
        },
        {
          text: this.$t("consultantUnit"),
          value: "assignedUnitCode",
          filterable: false,
          fixed: true
        },
        {
          text: this.$t("investmentConsultant"),
          value: "assignedName",
          filterable: false,
          fixed: true
        },
        {
          text: this.$t("channelInformation"),
          value: "channel",
          filterable: false,
          fixed: true
        },
        {
        text: this.$t("applicationInformation"),
          value: "applicationInformation",
          filterable: false,
          fixed: true
        },
        {
          text: this.$t("meetingPreference"),
          value: "meetingPreference",
          filterable: false
        }
      ];

      if (this.showSelect) {
        headers.unshift({
          text: "",
          value: "",
          filterable: false
        });
      }

      return headers;
    }
  },
  created() {
    this.PAGE_TYPE = "LeadPartyList";
  },
  methods: {
    getData() {
      this.refreshing = true;
      const checkedItemIds = this.list.reduce(
        (a, curr) => (curr.checked ? a.concat(curr.id) : a),
        []
      );
      this.getAllLeadPartyRequest = new GetAllLeadPartyRequest();
      this.getAllLeadPartyRequest.partyStatues = [
        "Rejected",
        "SelfPending",
        "SelfSuspended",
        "PreRejected",
        "Suspended",
        "NewParty"
      ];
      this.getAllLeadPartyRequest.leadPartyDTO.domainId = this.$store.getters[
        "user"
      ].domainId;
      this.getAllLeadPartyRequest.leadPartyDTO.tckn =
        this.searchTckn != null && this.searchTckn != ""
          ? this.searchTckn
          : null;
      this.getAllLeadPartyRequest.pageSize = this.pageOptions.itemsPerPage;
      this.getAllLeadPartyRequest.page = this.pageOptions.page - 1;
      this.getAllLeadPartyRequest.assigneeUnitCode = this.searchUnitCode;
      this.getAllLeadPartyRequest.leadPartyApplicationName = this.applicationName != null && this.applicationName != '' ? this.applicationName === 'Herkese Borsa' ? 'herkeseborsa' : 'trademaster' : null;
      this.getAllLeadPartyRequest.assignee =
      this.searchAssignedName != null && this.searchAssignedName != ""
        ? this.searchAssignedName
        : null;
      this.getAllLeadPartyRequest.leadIds =
        this.leadIds.length > 0 ? this.leadIds : null;
      LeadPartyApi.findAll(
        this,
        this.getAllLeadPartyRequest,
        response => {
          this.list = response.leadPartyDTOList.content;
          this.totalItems = response.leadPartyDTOList.totalElements;
          this.checkPreviouslyCheckedItems(checkedItemIds);
          this.refreshing = false;
        },
        error => {
          console.log(error);
          this.refreshing = false;
        }
      );
    },
    onClickChooseProcess(id) {
      this.$emit("onClickChooseProcess", id);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/LeadPartyListTable.js